import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Footer from "./components/Footer";
import NavMenu from "./components/NavMenu";
import ScrollToTop from "./components/ScrollToTop";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Home from "./pages/Home";
import Achievements from "./pages/Achievements";
import Projects from "./pages/Projects";
import SSNotes from "./pages/SSNotes";
import Trainings from "./pages/Trainings";
import PaperInsights from "./pages/PaperInsights";

export default function App() {
  return (
    <>
      <Router>
        <NavMenu />
        <ScrollToTop />
        <Switch>
          <Route path="/about">
            <About />
          </Route>
          <Route path="/contact">
            <Contact />
          </Route>
          <Route path="/projects">
            <Projects />
          </Route>

          <Route path="/my-certificates">
            <Achievements />
          </Route>
          <Route path="/sujan-sir-ko-notes">
            <SSNotes />
          </Route>
          <Route path="/trainings">
            <Trainings />
          </Route>
          <Route path="/paper-insights">
            <PaperInsights />
          </Route>
          <Route path="/">
            <Home />
          </Route>
        </Switch>
        <Footer />
      </Router>
    </>
  );
}
